import { useState, useEffect } from "react";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import {
  InputGroup,
  Button,
  Col,
  Accordion,
  Card,
  Row,
  Spinner,
} from "react-bootstrap";

import _ from "lodash";
import { FormProvider, useForm, Controller } from "react-hook-form";
import DataGrid from "./DataGrid";
import { useLocation, useNavigate } from "react-router-dom";
import { AssignCommissionGroupToSupplier } from "./AssignCommissionGroupModal";
import AddCircle from "@mui/icons-material/AddCircleRounded";
import { tools } from "../../../core/utils/tools";
import SelectComponent from "../_Components/ReactSelectComponent";
import ApiAgentCommission from "../../../core/api/api.agentCommission";
import ApiSupplierAgentCommission from "../../../core/api/api.supplierAgentCommission";
import GlobalFormControl from "../_Components/GlobalFormControl";

const SupplierAgentCommission = (props) => {
  const [listData, setListData] = useState();
  const [allSupplierAgents, setAllSupplierAgents] = useState([]);
  const [showAddCommissionToAgentModal, setShowAddCommissionToAgentModal] =
    useState(false);
  const [selectedAgentId, setSelectedAgentId] = useState(false);
  const [selectedCheckBoxes, setSelectedCheckBoxes] = useState([]);
  const [allCommissionGroups, setAllCommissionGroups] = useState([]);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
    reset,
  } = useForm({});
  const methods = {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
  };
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);

  useEffect(() => {
    (async () => {
      try {
        const data =
          await ApiSupplierAgentCommission.getAllSupplierAgentCommissions({
            pageSize: getValues("pageSize"),
            pageNumber: getValues("pageNumber"),
            globalSearch: searchParams.get("globalSearch"),
            agentId: searchParams.get("agentId"),
            agentCommissionId: searchParams.get("agentCommissionId"),
          });
        const allSupplierAgntsWithoutPagination =
          await ApiSupplierAgentCommission.getAllAgentBySupplierId();
        setAllSupplierAgents(allSupplierAgntsWithoutPagination);
        setListData(data);
        setValue("totalCount", data.totalCount);

        const allCommissionGroupsFromResponse =
          await ApiAgentCommission.getAllAgentCommissionsWithoutPagination();
        setAllCommissionGroups(allCommissionGroupsFromResponse.data);
        const formattedSupplierWithoutPagination =
          allSupplierAgntsWithoutPagination?.data
            ? allSupplierAgntsWithoutPagination?.data.map((item) => ({
              id: item.id,
              name: item.companyName,
            }))
            : [];

        const formInputs = [
          { name: "globalSearch", type: "text", defaultValue: "" },
          { name: "pageSize", type: "number", defaultValue: "" },
          { name: "pageNumber", type: "number", defaultValue: "" },
          {
            name: "agentId",
            type: "multiSelect",
            defaultValue: "",
            data: formattedSupplierWithoutPagination,
          },
          {
            name: "agentCommissionId",
            type: "multiSelect",
            defaultValue: "",
            data: allCommissionGroupsFromResponse.data,
          },
        ];

        tools.setInputsValues_ReactHookFrom(setValue, searchParams, formInputs);
      } catch (error) {
      }
    })();
  }, []);

  const onSubmit = async (data) => {
    data.agentId = data.agentId?.value;
    data.agentCommissionId = data.agentCommissionId?.value;
    tools.setPageNumber(data, searchParams, setValue);
    const apiData =
      await ApiSupplierAgentCommission.getAllSupplierAgentCommissions(data);
    setListData(apiData);
    setValue("totalCount", apiData.totalCount);
    const queryString = tools.createQueryStringFromFromData(
      _.omit(data, ["totalPages", "totalCount"])
    );
    navigate(`/supplierAgentCommissions?${queryString}`);
  };

  return (
    <div>
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pb-3 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">
              تخصیص گروه کمیسیون به نمایندگان
            </span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">
              لیست گروه های کمیسیون تخصیص یافته به نمایندگان
            </span>
          </h3>
          <div className="card-toolbar">
            <Button
              className="btn btn-primary"
              onClick={() => {
                setSelectedAgentId(0);
                setShowAddCommissionToAgentModal(true);
              }}
            >
              <AddCircle className="mr-1" />
              تخصیص گروه کمیسیون
            </Button>
          </div>
        </div>
        {/*Start body */}
        <div className="card-body pt-3 pb-0">
          <FormProvider {...methods}>
            <form id="form" onSubmit={methods.handleSubmit(onSubmit)}>
              {/* search box */}
              <div className="border-top pt-3">
                <Accordion className="search">
                  <Card>
                    <Accordion.Header
                      as={Card.Header}
                      variant="link"
                    >
                      <Card.Title className="py-0 pl-0 fs-normal text-gray">
                        جستجو پیشرفته
                      </Card.Title>
                    </Accordion.Header>
                    <Accordion.Body>
                      <Card.Body>
                        <Row>
                          <Col sm="6" xl="3">
                            <Controller
                              name="agentId"
                              control={control}
                              rules={{}}
                              render={({ field }) => (
                                <SelectComponent
                                  className="mt-0 mb-5"
                                  placeholder=" نماینده"
                                  options={allSupplierAgents?.data?.map(
                                    (item) => ({
                                      value: item.id,
                                      label: item.companyName,
                                    })
                                  )}
                                  field={field}
                                />
                              )}
                            />

                            {/* <Controller
                              control={control}
                              name={"agentId"}
                              render={({ field }) => (
                                <Select
                                  name="service"
                                  inputId="react-select-with-search"
                                  className="mt-5"
                                  variant="outlined"
                                  size="small"
                                  placeholder=" نماینده"
                                  TextFieldProps={{
                                    label: "Services2",
                                    InputLabelProps: {
                                      htmlFor: "react-select-multiple",
                                      shrink: true,
                                    },
                                  }}
                                  options={allSupplierAgents?.data?.map(
                                    (item) => ({
                                      value: item.id,
                                      label: item.companyName,
                                    })
                                  )}
                                  {...field}
                                />
                              )}
                            /> */}
                          </Col>
                          <Col sm="6" xl="3">
                            <Controller
                              name="agentCommissionId"
                              control={control}
                              rules={{}}
                              render={({ field }) => (
                                <SelectComponent
                                  className="mt-0 mb-5"
                                  placeholder=" گروه کمیسیون"
                                  options={allCommissionGroups?.map((item) => ({
                                    value: item.id,
                                    label: item.name,
                                  }))}
                                  field={field}
                                />
                              )}
                            />
                            {/* <Controller
                              control={control}
                              name={"agentCommissionId"}
                              render={({ field }) => (
                                <Select
                                  name="service"
                                  // style={selectStyles}
                                  inputId="react-select-with-search"
                                  className="mt-5"
                                  variant="outlined"
                                  size="small"
                                  placeholder=" گروه کمیسیون"
                                  TextFieldProps={{
                                    label: "Services2",
                                    InputLabelProps: {
                                      htmlFor: "react-select-multiple",
                                      shrink: true,
                                    },
                                  }}
                                  options={allCommissionGroups?.map((item) => ({
                                    value: item.id,
                                    label: item.name,
                                  }))}
                                  {...field}
                                />
                              )}
                            /> */}
                          </Col>
                        </Row>
                        <Row className="">
                          <Col xs="12" className="tb-reponsive">
                            <Button
                              variant="success"
                              type="submit"
                              className="py-2 mr-2 mb-2"
                              disabled={isSubmitting}
                            >
                              {isSubmitting && (
                                <Spinner
                                  animation="border"
                                  variant="warning"
                                  size="sm"
                                />
                              )}
                              <SearchIcon />
                              جستجو
                            </Button>
                            <Button
                              className="py-2 mb-2"
                              variant="light-danger"
                              type="submit"
                              disabled={isSubmitting}
                              onClick={() =>
                                tools.handleResetAdvanceSearchBox(watch, reset)
                              }
                            >
                              {isSubmitting && (
                                <Spinner
                                  animation="border"
                                  variant="warning"
                                  size="sm"
                                />
                              )}
                              <i className="fas fa-refresh text-small"></i>
                              حذف جستجو{" "}
                            </Button>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Accordion.Body>
                  </Card>
                </Accordion>
                <InputGroup className="my-3">
                  <Controller
                    name="globalSearch"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <GlobalFormControl
                        type="text"
                        aria-describedby="basic-addon1"
                        placeholder="جستجو ..."
                        name="globalSearch"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />

                  <Button
                    variant="secondary"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <Spinner animation="border" variant="warning" size="sm" />
                    ) : (
                      <SearchIcon />
                    )}
                  </Button>
                </InputGroup>
              </div>
              {/* table */}
              <Col xs="12" className="tb-reponsive px-0">
                <DataGrid
                  data={listData}
                  setSelectedAgentId={setSelectedAgentId}
                  setShowAddCommissionToAgentModal={
                    setShowAddCommissionToAgentModal
                  }
                  setSelectedCheckBoxes={setSelectedCheckBoxes}
                  selectedCheckBoxes={selectedCheckBoxes}
                />
              </Col>
            </form>
          </FormProvider>

          {showAddCommissionToAgentModal && (
            <AssignCommissionGroupToSupplier
              setShowAddCommissionToAgentModal={
                setShowAddCommissionToAgentModal
              }
              selectedAgentId={selectedAgentId}
              selectedCheckBoxes={selectedCheckBoxes}
              allSupplierAgents={allSupplierAgents}
              allCommissionGroups={allCommissionGroups}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default SupplierAgentCommission;
